var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.246 10.5L11.828 0H3.6L0.162 9C0.0559999 9.32 0 9.652 0 10C0 12.208 2.3 14 5.142 14C7.762 14 9.928 12.472 10.246 10.5Z",
    fill: "#FD784C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.84 9L32.398 0H24.172L25.752 10.484C26.06 12.464 28.226 14 30.858 14C33.698 14 36 12.208 36 10C36 9.652 35.944 9.32 35.84 9Z",
    fill: "#FD784C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14C20.84 14 23.142 12.208 23.142 10C23.142 9.93672 23.1384 9.87344 23.135 9.81199L23.132 9.758L22.114 0H13.886L12.866 9.75C12.862 9.832 12.858 9.914 12.858 10C12.858 12.208 15.16 14 18 14Z",
    fill: "#FD784C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16.092V24H8V16.104C7.124 16.42 6.16 16.6 5.142 16.6C4.752 16.6 4.374 16.554 4 16.502V29.2C4 30.74 5.258 32 6.796 32H29.2C30.74 32 32 30.738 32 29.2V16.504C31.6219 16.562 31.2404 16.5948 30.858 16.602C29.8828 16.601 28.9154 16.4284 28 16.092Z",
    fill: "#47BE79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreIcon3);
export default __webpack_public_path__ + "static/media/storeIcon3.73d32d15e20d2bcde7f21f2c1b3ddfd2.svg";
export { ForwardRef as ReactComponent };